export default function() {
  return {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: ''
  }
}
